import InfoBox from "../ui/InfoBox"
import SectionHeader from "../ui/SectionHeader"
import { FiFlag } from "react-icons/fi"
import AddPriorityBox from "./AddPriorityBox"

type PrioritySectionProps = {
  onChange?: (list: any[]) => void
  initialData?: any[] | null
  disabled?: boolean
}

export default function PrioritySection({
  onChange,
  initialData,
  disabled = false
}: PrioritySectionProps) {
  return (
    <div>
      <SectionHeader icon={<FiFlag size={20} />} title="Priority">
        <InfoBox title="Claiming priority">
          If this invention was already filed at another office within
          the last 12 months, you can claim priority from that earlier
          filing (Paris Convention). Leave this empty if there is none.
        </InfoBox>
      </SectionHeader>

      <AddPriorityBox
        onChange={onChange}
        initialData={initialData || undefined}
        disabled={disabled}
      />
    </div>
  )
}
